import React from 'react';
import MobileMenu from "../components/header/MobileMenu";
import Seo from "../components/common/Seo";
import HeroBlock from "./homepage/HeroBlock";
import ForumBlock from "./homepage/ForumBlock";
import FormationBlock from "./homepage/FormationBlock";
import HotlineBlock from "./homepage/HotlineBlock";
import VideoBlock from "./homepage/VideoBlock";
import CtaBlock from "./homepage/CtaBlock";
import TrustBlock from "./homepage/TrustBlock";
import ContactBlock from "./homepage/ContactBlock";
import FooterBlock from "./homepage/FooterBlock";
import HeaderBlock from "./homepage/HeaderBlock";
import WebinairesBlock from "./homepage/WebinairesBlock";

const Homepage = () => {
    return (
        <>
            <Seo
                pageTitle='Groupe Talents Handicap'
                pageDescription="Groupe Talents Handicap"
                pageUrl={window.location.href}
                imageUrl="/images/share-picture.png"
            />
            <HeaderBlock/>
            <MobileMenu/>
            <HeroBlock/>
            <ForumBlock/>
            <FormationBlock/>
            <WebinairesBlock/>
            <HotlineBlock/>
            <VideoBlock/>
            <CtaBlock/>
            <TrustBlock/>
            <ContactBlock/>
            <FooterBlock/>
        </>
    );
};

export default Homepage;
